<template>
  <div class="h-full bg-zinc-900">
    <div class="h-full">
      <div class="min-h-screen m-auto max-w-5xl flex flex-col text-white justify-center items-center">

        <span class="text-6xl font-mono">Je bent momenteel offline.</span>
        <div class="space-y-3 text-lg text-center mt-3">
          <p>Om gegevensverlies en eventuele fouten te voorkomen, is het dashboard tijdelijk niet beschikbaar.</p>
          <p>Zodra je internetverbinding is hersteld, kun je het dashboard meteen weer gebruiken!</p>
          <p class="font-bold text-red-600 italic">
            Om de gegevens te beschermen, zijn alle wijzigingen die nog niet waren opgeslagen verwijderd.
            <br>
            Je zult deze aanpassingen opnieuw moeten doen zodra je weer online bent.
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>